
import { defineComponent } from 'vue'
import { APIClient } from '@/lib/api-client'
import { Item, AchievementLevel } from '@/types'

import SuzuriHeader from '@/components/SuzuriHeader.vue'
import AchievementLevelTable from '@/components/AchievementLevelTable.vue'

interface Data {
  achievementLevels: { [key: string]: AchievementLevel[]; }
}

export default defineComponent({
  components: {
    SuzuriHeader,
    AchievementLevelTable
  },
  data (): Data {
    return {
      achievementLevels: {}
    }
  },
  async mounted () {
    const items = await APIClient.get<Item[]>('/items').then(res => res.data)
    const achievementLevels = await APIClient.get<AchievementLevel[]>('/achievement_levels').then(res => res.data)

    this.achievementLevels = Object.fromEntries(
      items.map(item => [
        item.name,
        achievementLevels.filter(level => level.itemId === item.id)
      ])
    )
  }
})
